import React, { useEffect, useRef, useState } from "react";
import {IonFooter, IonGrid, IonRow, IonCol, IonButton, IonIcon, IonLabel} from "@ionic/react";
import { useKeyboard } from "./KeyboardProvider";
import { LETTERS, SYMBOLS } from "./KeyboardLayouts";
import { backspace } from "ionicons/icons";
import { useDeviceType } from "../../hooks/useDeviceType";

export const CustomKeyboard: React.FC = () => {
    const { isOpen, value, setValue, closeKeyboard, layout, setLayout, activeInputRef } = useKeyboard();
    const [isShift, setIsShift] = useState(false);
    const [pressedKey, setPressedKey] = useState<string | null>(null);
    const keyboardRef = useRef<any>(null);
    const device = useDeviceType()

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node;
            if (
                isOpen &&
                keyboardRef.current &&
                !keyboardRef.current.contains(target) &&
                activeInputRef &&
                !activeInputRef.contains(target)
            ) {
                closeKeyboard();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, closeKeyboard, activeInputRef]);

    if (!isOpen) return null;

    const currentLayout = layout === "letters" ? LETTERS : SYMBOLS;

    const handleKey = (key: string) => {
        if (navigator.vibrate) navigator.vibrate(20);

        setPressedKey(key);
        setTimeout(() => setPressedKey(null), 100);

        switch (key) {
            case "backspace":
                setValue(value.slice(0, -1));
                break;
            case "space":
                setValue(value + " ");
                break;
            case "enter":
                closeKeyboard();
                break;
            case "shift":
                setIsShift(!isShift);
                break;
            case "123":
                setLayout("symbols");
                break;
            case "ABC":
            case "abc":
                setLayout("letters");
                break;
            default:
                setValue(value + (isShift ? key.toUpperCase() : key));
                if (isShift) setIsShift(false);
        }
    };

    return (
        <IonFooter
            ref={keyboardRef}
            style={{
                position: "fixed",
                bottom: 0,
                width: "100%",
                background: "#fff",
                boxShadow: "0 -2px 10px rgba(0,0,0,0.15)",
                zIndex: 1000,
            }}
        >
            <IonGrid>
                {currentLayout.map((row, rowIndex) => {
                    return (
                    <IonRow key={rowIndex} style={{ justifyContent: "center" }}>
                        {row.map((key) => {
                            const isSpaceBtn = key === "space";
                            let minWidth;
                            if(isSpaceBtn){
                                if(device === 'phone'){
                                    minWidth = 100
                                } else {
                                    minWidth = 200
                                }
                            } else {
                                if(device === 'phone'){
                                    minWidth = 25
                                } else {
                                    minWidth = 50
                                }
                            }
                            return (
                            <IonCol size="auto" key={key} style={{ padding: device === 'phone' ? 1 : 4 }}>
                                <IonButton
                                    color={'secondary'}
                                    expand="block"
                                    onClick={() => handleKey(key)}
                                    onTouchStart={() => setPressedKey(key)}
                                    onTouchEnd={() => setPressedKey(null)}
                                    onMouseDown={() => setPressedKey(key)}
                                    onMouseUp={() => setPressedKey(null)}
                                    onMouseLeave={() => setPressedKey(null)}
                                    style={{
                                        minWidth: minWidth,
                                        fontSize:  device !== 'phone' ? "1.2rem" : '0.7rem',
                                    }}
                                >
                                    {key === "backspace" ? (
                                        <IonIcon icon={backspace} />
                                    ) : key === "space" ? (
                                        "SPAZIO"
                                    ) : (
                                        <IonLabel>
                                            {key.toUpperCase()}
                                        </IonLabel>
                                    )}
                                </IonButton>
                            </IonCol>
                            )
                        })}
                    </IonRow>
                    )
                })}
            </IonGrid>
        </IonFooter>
    );
};
